import {
    LOG_OUT, CORRECTION_REQUEST, STAFF_KPI, CLOCK_IN_STATUS, UPDATE_PROFILE,
    STAFF_TRAINING_VIDEOS
} from "./ActionTypes";
import StaffDashboardService from "../services/StaffDasboardService";
import {getUser} from "../utils/TokenManager";


const logOutSuccess = () => ({type: LOG_OUT});
const staffKPI = (staffKPIList) => ({type: STAFF_KPI, staffKPIList});
const clockInStatus = (status) => ({type: CLOCK_IN_STATUS, status});
const correctionRequests = (requests) => ({type: CORRECTION_REQUEST, requests});
const updateProfileSuccess = (profileData) => ({type: UPDATE_PROFILE, profileData});


export const getStaffKPI = () => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.getStaffKPI();
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(staffKPI(result.data));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getClockInStatus = () => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.getClockInOut();
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            
            if (200 === result.status) {
                dispatch(clockInStatus(result.data.user_time_clock));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const postClockIn = () => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.postClockIn();
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (201 === result.status) {
                dispatch(clockInStatus(result.data.user_time_clock));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);
export const putClockOut = (reason) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.putClockOut(reason);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(clockInStatus(result.data.user_time_clock));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getStaffCorrectionRequests = () => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.getStaffCorrections();
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(correctionRequests(result.data.correction_request));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const postCorrectionRequest = (requestData, oldRequestListProps) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.postRequestCorrection(requestData);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (201 === result.status) {
                let oldRequestList = oldRequestListProps.map(request => ({...request}));
                let correctionRequestList = [result.data.correction_request, ...oldRequestList]
                dispatch(correctionRequests(correctionRequestList));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const setPassword = (passwordDetail) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.setPassword(passwordDetail);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                // No need to logout, because token is still valid.
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);


export const updateProfile = (profileDetail) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.setUserProfile(profileDetail);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                dispatch(updateProfileSuccess(result.data));
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getDepartmentList = (all=0) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.getDepartmentList(all);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getScores = (all=0) => (
    async (dispatch) => {
        try {
            const result = await StaffDashboardService.getScore(all);
            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }
            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getLocationCount = () => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.getLocationCount();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getStaffCompensationList = () => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.getStaffCompensationList();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const staffRevenues = (compProfileId, revenues, method) => (
    async (dispatch) => {
        try {
            let result;
            if (method === "GET") {
                result = await StaffDashboardService.getStaffRevenues(compProfileId);
            } else {
                result = await StaffDashboardService.updateStaffRevenues(revenues);
            }

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }

        return false;
    }
);

export const getAgencyTotalRevenue = (plProfileId) => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.getAgencyTotalRevenues(plProfileId);

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const updateDashboardVideoStatus = () => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.updateDashboardVideoStatus();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return true;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getFirstTimeVideo = () => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.getFirstTimeVideo();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                return result.data;
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);

export const getTrainingVideoList = () => (
    async (dispatch) => {
        try {
            let result = await StaffDashboardService.getTrainingVideoList();

            if (getUser()['app-version'] !== result.headers['app-version']) {
                dispatch(logOutSuccess());
            }

            if (200 === result.status) {
                dispatch({type: STAFF_TRAINING_VIDEOS, videoList: result.data});
            }
        } catch (error) {
            if(401 === error.response.status) {
                dispatch(logOutSuccess());
                return false;
            }
            throw error.response;
        }
        return false;
    }
);



// WEBPACK FOOTER //
// ./src/actions/StaffDashboardAction.js